import { APISettings } from "../../config/ApiSettings";
import { BaseAPI } from "./baseApi";
const baseUrl = new APISettings().getApiURL();

class WorkflowStatusActionApi<WorkflowStatusAction> extends BaseAPI {
    public getById: (id: number) => Promise<WorkflowStatusAction> = async(id: number) => {
        return (await BaseAPI.axios.get(`${baseUrl}/WorkflowStatusAction/${id}`)).data.output;
    }

    public getByStatusId: (id: number) => Promise<WorkflowStatusAction[]> = async(id: number) => {
        return (await BaseAPI.axios.get(`${baseUrl}/WorkflowStatusAction/GetByStatusId/${id}`)).data.output;
    }
}

export const workflowStatusActionApi = new WorkflowStatusActionApi();